import { Button, Form, Input } from 'antd';
import { FormItemInputProps } from 'antd/lib/form/FormItemInput';
import React, { useRef } from 'react';
import styles from './index.module.scss';
import GeeTest from '../../GeeTest/index';

interface IProps {
  countDown: number;
  isDisposed: boolean;
  name?: string;
  help?: FormItemInputProps['help'];
  loading?: boolean;
  disabled?: boolean;
  form?: any;
  targetValication?: string;
  onClick?: (slidingCaptcha: any) => void;
  onChange?: (value: string) => void;
}

const LoginMobileCaptchaItem: React.FC<IProps> = ({
  name = 'mobileCaptcha',
  onChange,
  help,
  disabled,
  onClick,
  countDown,
  isDisposed,
  loading,
  form,
  targetValication
}) => {
  const gee = useRef(null);

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = e.target.value.replace(/\s/g, '');
    onChange && onChange(e.target.value);
  };

  const onSendVerifyCode = async () => {
    if (disabled) return;
    if (countDown > 0) return;
    console.log(form, targetValication, 'form');
    await form.validateFields([targetValication]);
    gee.current && gee.current?.captchaObj?.verify();
  };

  const validateStatus = help ? 'error' : undefined;

  const handleSuccess = async (handleSuccess: any) => {
    const slidingCaptcha = {
      challenge: handleSuccess.key,
      validate: handleSuccess.captcha,
      seccode: handleSuccess.seccode
    };
    onClick && onClick(slidingCaptcha);
  };

  return (
    <>
      <Form.Item
        name={name}
        validateStatus={validateStatus}
        help={help || undefined}
        rules={[
          {
            required: true,
            message: '请输入验证码'
          }
        ]}
        getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
        validateTrigger="onBlur"
      >
        <Input
          size="large"
          maxLength={6}
          placeholder="请输入验证码"
          onChange={onInputChange}
          suffix={
            <div className={styles.link}>
              <Button type="link" loading={loading} onClick={onSendVerifyCode} disabled={disabled}>
                {countDown > 0 ? `${countDown}s` : isDisposed ? '重新获取' : '获取验证码'}
              </Button>
            </div>
          }
        />
      </Form.Item>
      <GeeTest
        getRef={(ref: any) => (gee.current = ref)}
        appCode="maxhub-integration-server"
        product="bind"
        https
        onSuccess={handleSuccess}
        lang="zh-cn"
      ></GeeTest>
    </>
  );
};

export default LoginMobileCaptchaItem;
